<template>
  <div
    class="mt-6 flex justify-start items-start flex-col w-full h-auto bg-transparent overflow-visible"
  >
    <report-selector label="Weekly" v-model="selection">
      <option
        v-for="(i, index) in reportsOrdered"
        :key="i.id + '_option_' + index"
        :value="i.id"
      >
        {{ getDateRange(i.date.seconds) }}
      </option>
    </report-selector>
    <div v-if="doc" class="relative mt-3">
      <s-button class="shadow-lg" @click.stop="actionsOpen = !actionsOpen">
        Actions
      </s-button>
      <div
        v-if="actionsOpen"
        class="absolute left-0 mt-1 w-56 bg-white rounded-lg shadow-lg py-1 z-50 border border-gray-200"
      >
        <button
          v-if="isManager || isAdmin"
          @click="edit(); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Edit
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="downloadCsv(reportCsvByReportId(selection)); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="exportInvoices"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export Invoices
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="exportMonthInvoices"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export Month Invoices
        </button>
        <button
          v-if="isAdmin || isManager"
          @click="exportTransfers"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Export Transfers
        </button>
        <button
          v-if="isManager || isAdmin"
          @click="$modal.show('modal--generate-report'); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors"
        >
          Create
        </button>
        <button
          v-if="isAdmin"
          @click="deleteReport(selection); actionsOpen = false"
          class="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
    <div v-if="actionsOpen" class="fixed inset-0 z-40" @click="actionsOpen = false" />
    <report-table v-if="doc">
      <div class="flex flex-col justify-start">
        <table
          class="text-left w-full border-collapse overflow-scroll leading-none whitespace-nowrap"
        >
          <tbody>
            <!-- <tr class="px-2">
              <td
                class="pt-2 text-5xl text-gray-700 font-bold leading-none"
                colspan="12"
              >
                Guest Count
              </td>
            </tr>
            <tr class="text-center">
              <th
                class="pb-1 px-2 border-b whitesapce-no-wrap bg-white text-gray-700"
                v-for="(heading, index) in headings"
                :key="`${heading}-${index}`"
              >
                {{ heading }}
              </th>
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">
                In Store
              </td>
              <td
                v-for="(day, index) in doc.guests.inStore"
                :key="`${index}_guestsInStore`"
                class="py-1 px-2 bg-yellow-200 border-b text-center"
              >
                {{ day }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-center">
                {{ doc.guests.inStoreTotal }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.guests.inStorePercent | percent }}
              </td>

              <td class="py-1 px-2 bg-gray-100 border-b text-center">-</td>
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">
                Delivery
              </td>
              <td
                v-for="(day, index) in doc.guests.delivery"
                :key="`${index}_guestsDelivery`"
                class="py-1 px-2 bg-yellow-200 border-b text-center"
              >
                {{ day }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-center">
                {{ doc.guests.deliveryTotal }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.guests.deliveryPercent | percent }}
              </td>

              <td class="py-1 px-2 bg-gray-100 border-b text-center">-</td>
            </tr>
            <tr class="px-2 bg-gray-200 hover:bg-gray-100">
              <td class="py-3 px-2 whitespace-normal">
                Total
              </td>
              <td
                v-for="(day, index) in doc.guests.totals"
                :key="`${index}_guestsTotal`"
                class="py-3 px-2 text-center"
              >
                {{ day }}
              </td>
              <td class="py-3 px-2"></td>
              <td class="py-3 px-2 bg-gray-200 text-center">
                {{ doc.guests.total }}
              </td>
              <td class="py-3 px-2 bg-gray-200 text-center">-</td>
              <td class="py-3 px-2 bg-gray-200 text-center">-</td>
            </tr> -->
            <tr class="text-center">
              <th
                class="pt-6 text-5xl text-left text-gray-700 font-bold leading-none"
                colspan="12"
              >
                Sales
              </th>
            </tr>
            <tr class="text-center">
              <th
                class="pb-1 px-2 border-b whitesapce-no-wrap bg-white text-gray-700"
                v-for="(heading, index) in headings"
                :key="`${heading}-${index}`"
              >
                {{ heading }}
              </th>
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">In Store</td>
              <td
                v-for="(day, index) in doc.sales.inStore"
                :key="`${index}_salesInStore`"
                class="py-1 px-2 bg-yellow-200 border-b text-right"
              >
                {{ day | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.inStoreTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.inStorePercent | percent }}
              </td>

              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.inStorePerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">Delivery</td>
              <td
                v-for="(day, index) in doc.sales.delivery"
                :key="`${index}_salesDelivery`"
                class="py-1 px-2 bg-yellow-200 border-b text-right"
              >
                {{ day | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.deliveryTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right" rowspan="2">
                {{ doc.sales.deliveryPercent | percent }}
              </td>

              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.deliveryPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 italic hover:bg-gray-100">
              <td class="py-1 px-2 bg-yellow-200 border-b whitespace-normal">
                Delivery Fees ({{ Math.abs(doc.sales.fees) | percent }})
              </td>
              <td
                v-for="(day, index) in doc.sales.deliveryFees"
                :key="`${index}_salesFees`"
                class="py-1 px-2 border-b text-right"
              >
                {{ day | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.deliveryFeesTotal | usd }}
              </td>
              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-center"></td> -->

              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.sales.deliveryFeesPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 bg-gray-200 hover:bg-gray-100">
              <td class="py-3 px-2 whitespace-normal">Total</td>
              <td
                v-for="(day, index) in doc.sales.totals"
                :key="`${index}_salesTotal`"
                class="py-3 px-2 text-right"
              >
                {{ day | usd }}
              </td>
              <td class="py-3 px-2"></td>
              <td class="py-3 px-2 bg-gray-200 text-right">
                {{ doc.sales.total | usd }}
              </td>
              <td class="py-3 px-2 bg-gray-200 text-center">-</td>

              <!-- <td class="py-3 px-2 bg-gray-200 text-right">
                {{ doc.sales.totalPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2">
              <td
                class="pt-6 text-5xl text-gray-700 font-bold leading-none"
                colspan="12"
              >
                Payroll
              </td>
            </tr>
            <tr class="text-center">
              <th
                class="pb-1 px-2 border-b whitesapce-no-wrap bg-white text-gray-700"
                v-for="(heading, index) in headings"
                :key="`${heading}-${index}`"
              >
                {{ heading }}
              </th>
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">Management</td>
              <td
                v-for="(amount, index) in doc.payroll.management"
                :key="`${index}_payrollManagement`"
                class="py-1 px-2 border-b text-right"
              >
                {{ amount | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-yellow-200 border-b text-right">
                {{ doc.payroll.managementTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.managementPercent | percent }}
              </td>

              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.managementPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">
                Hourly Personnel
              </td>
              <td
                v-for="(amount, index) in doc.payroll.hourly"
                :key="`${index}_payrollHourly`"
                class="py-1 px-2 border-b bg-yellow-200 text-right"
              >
                {{ amount | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.hourlyTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.hourlyPercent | percent }}
              </td>
              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.hourlyPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 bg-yellow-200 border-b whitespace-nowrap">
                Taxes & Benefits ({{ Math.abs(doc.payroll.fees) | percent }})
              </td>
              <td
                v-for="(amount, index) in doc.payroll.taxes"
                :key="`${index}_payrollTaxes`"
                class="py-1 px-2 border-b text-right"
              >
                {{ amount | usd }}
              </td>
              <td class="py-1 px-2 border-b"></td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.taxesTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.taxesPercent | percent }}
              </td>

              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.payroll.taxesPerGuest | usd }}
              </td> -->
            </tr>

            <tr class="px-2 bg-gray-200 hover:bg-gray-100">
              <td class="py-3 px-2 whitespace-normal">Total</td>
              <td
                v-for="(amount, index) in doc.payroll.totals"
                :key="`${index}_payrollTotals`"
                class="py-3 px-2 text-right"
              >
                {{ amount | usd }}
              </td>
              <td class="py-3 px-2"></td>
              <td class="py-3 px-2 bg-gray-200 text-right">
                {{ doc.payroll.total | usd }}
              </td>
              <td class="py-3 px-2 bg-gray-200 text-right">
                {{ doc.payroll.totalPercent | percent }}
              </td>

              <!-- <td class="py-3 px-2 bg-gray-200 text-right">
                {{ doc.payroll.totalPerGuest | usd }}
              </td> -->
            </tr>

            <tr class="px-2">
              <td
                class="pt-6 text-5xl text-gray-700 font-bold leading-none"
                colspan="12"
              >
                Cost of Goods
              </td>
            </tr>
            <tr class="text-center">
              <th
                class="pb-1 px-2 border-b whitesapce-no-wrap bg-white text-gray-700"
                :colspan="index > 0 && index < 5 ? 2 : 1"
                v-for="(heading, index) in cogHeadings"
                :key="`${heading}-${index}`"
              >
                {{ heading }}
              </th>
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">Food</td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryBeginningFood | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryEndingFood | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryDifferenceFood | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.invoicesFood | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.foodTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.foodPercent | percent }}
              </td>
              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.foodPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 hover:bg-gray-100">
              <td class="py-1 px-2 border-b whitespace-normal">Other</td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryBeginningOther | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryEndingOther | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.inventoryDifferenceOther | usd }}
              </td>
              <td class="py-1 px-2 border-b text-right" colspan="2">
                {{ doc.cogs.invoicesOther | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.otherTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.otherPercent | percent }}
              </td>
              <!-- <td class="py-1 px-2 bg-gray-100 border-b text-right">
                {{ doc.cogs.otherPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="px-2 bg-gray-200 hover:bg-gray-100">
              <td class="py-3 px-2 whitespace-normal">Total</td>
              <td class="py-1 px-2 text-right" colspan="2">
                {{ doc.cogs.inventoryBeginningTotal | usd }}
              </td>
              <td class="py-1 px-2 text-right" colspan="2">
                {{ doc.cogs.inventoryEndingTotal | usd }}
              </td>
              <td class="py-1 px-2 text-right" colspan="2">
                {{ doc.cogs.inventoryDifferenceTotal | usd }}
              </td>
              <td class="py-1 px-2 text-right" colspan="2">
                {{ doc.cogs.invoicesTotal | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-200 text-right">
                {{ doc.cogs.total | usd }}
              </td>
              <td class="py-1 px-2 bg-gray-200 text-right">
                {{ doc.cogs.totalPercent | percent }}
              </td>
              <!-- <td class="py-1 px-2 bg-gray-200 text-right">
                {{ doc.cogs.totalPerGuest | usd }}
              </td> -->
            </tr>

            <tr class="text-center">
              <th colspan="9"></th>
              <th
                class="pt-8 pb-1 px-2 pt-2 whitesapce-no-wrap bg-white text-gray-700"
              >
                Total
              </th>
              <th
                class="pt-8 pb-1 px-2 pt-2 whitesapce-no-wrap bg-white text-gray-700"
              >
                Percent
              </th>
              <!-- <th
                class="pt-8 pb-1 px-2 pt-2 whitesapce-no-wrap bg-white text-gray-700"
              >
                Per Guest
              </th> -->
            </tr>
            <tr class="text-lg">
              <th
                class="py-1 text-xl leading-none text-right align-bottom pr-10 text-gray-700 font-bold"
                colspan="9"
              >
                Prime Cost
              </th>
              <td class="py-1 px-1 bg-gray-100 font-bold text-right border-b">
                {{ doc.primeCost | usd }}
              </td>
              <td class="py-1 px-1 bg-gray-100 font-bold text-right border-b">
                {{ doc.primeCostPercent | percent }}
              </td>
              <!-- <td class="py-1 px-1 bg-gray-100 font-bold text-right border-b">
                {{ doc.primeCostPerGuest | usd }}
              </td> -->
            </tr>
            <tr class="text-lg">
              <th
                class="py-1 text-xl leading-none text-right align-center pr-10 text-gray-700 font-bold"
                colspan="9"
              >
                Gross Margin
              </th>
              <td class="py-1 px-1 bg-gray-100 font-bold text-right">
                {{ doc.grossMargin | usd }}
              </td>
              <td class="py-1 px-1 bg-gray-100 font-bold text-right">
                {{ doc.grossMarginPercent | percent }}
              </td>
              <!-- <td class="py-1 px-1 bg-gray-100 font-bold text-right">
                {{ doc.grossMarginPerGuest | usd }}
              </td> -->
            </tr>
          </tbody>
        </table>
      </div>
    </report-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { floatify, downloadCsv } from '@/utils'
import SButton from '@/components/Button'
import ReportSelector from '@/components/ReportSelector'
import ReportTable from '@/components/ReportTable'
import { DateTime } from 'luxon'

export default {
  name: 'ReportsPrimeCosts',
  data() {
    return {
      selection: null,
      actionsOpen: false,
      headings: [
        '',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun',
        '',
        'Total',
        'Percent'
        // 'Per Guest'
      ],
      cogHeadings: [
        '',
        'Beginning Inventory',
        'Ending Inventory',
        'Difference',
        'Invoices',
        'Total',
        'Percent'
        // 'Per Guest'
      ]
    }
  },
  components: {
    SButton,
    ReportSelector,
    ReportTable
  },
  computed: {
    ...mapGetters('user', ['isAdmin', 'isManager']),
    ...mapGetters('storeModule/inventories', ['inventories', 'inventoryById']),
    ...mapGetters('storeModule/products', ['products']),
    ...mapGetters('storeModule/vendors', ['vendors']),
    ...mapGetters('storeModule/invoices', ['lastInvoiceByVendor']),
    ...mapGetters('storeModule/reports', [
      'reports',
      'reportsOrdered',
      'reportById',
      'reportCsvByReportId',
      'reportWeeklyInvoicesCsvByReportId',
      'reportWeeklyTransfersCsvByReportId',
      'reportPreviousMonthInvoicesCsv'
    ]),
    doc() {
      return this.reportById(this.selection)
    }
  },
  methods: {
    downloadCsv,
    ...mapActions('storeModule/reports', { deleteReport: 'delete' }),
    ...mapActions('storeModule', ['generateReport']),
    floatify,
    update() {
      this.generateReport({
        id: this.doc.id, // don't change
        date: this.doc.date.seconds * 1000, // don't change
        salesInStore: this.doc.sales.inStore,
        salesDelivery: this.doc.sales.delivery,
        guestsInStore: this.doc.guests.inStore,
        guestsDelivery: this.doc.guests.delivery,
        // totalPayrollManagement: this.doc.payroll.managementTotal,
        payrollHourly: this.doc.payroll.hourly,
        feesPayroll: this.doc.payroll.fees,
        feesDelivery: this.doc.sales.fees
      })
    },
    edit() {
      this.$modal.show('modal--generate-report', { id: this.doc.id })
    },
    exportInvoices() {
      this.actionsOpen = false
      this.reportWeeklyInvoicesCsvByReportId(this.selection).then((file) => this.downloadCsv(file))
    },
    exportMonthInvoices() {
      this.actionsOpen = false
      this.reportPreviousMonthInvoicesCsv(this.selection).then((file) => this.downloadCsv(file))
    },
    exportTransfers() {
      this.actionsOpen = false
      this.reportWeeklyTransfersCsvByReportId(this.selection).then((file) => this.downloadCsv(file))
    },
    getDateRange: function (date) {
      return `${DateTime.fromSeconds(date)
        .setZone('America/New_York')
        .minus({ weeks: 1 })
        .toLocaleString()}
       - ${DateTime.fromSeconds(date)
         .setZone('America/New_York')
         .minus({ days: 1 })
         .toLocaleString()}`
    },
    formatCsvContent(content) {
      let outputCsv = ''
      content.forEach((row) => {
        outputCsv += '"' + row.join('","') + '"'
        outputCsv += '\n'
      })
      return outputCsv
    }
  }
}
</script>

<style scoped>
.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}
.expand-enter-active {
  /* overflow: hidden; */
  transition: height 0.25s 0.1s ease-out, opacity 0.2s 0.2s ease-out;
  /* //if multiple expands, use this one */
  /* //transition: height 0.25s 0.3s ease-out, opacity 0.3s 0.5s ease-out; */
}
.expand-leave-active {
  /* overflow: hidden; */
  /* //if multiple expands, use this one */
  transition: opacity 0.05s ease-out, height 0.2s 0.1s ease-in;
}
</style>
